import { Directive, Injectable } from '@angular/core';
import { TuiDay, TuiValueTransformer } from '@taiga-ui/cdk';
import { TUI_DATE_VALUE_TRANSFORMER } from '@taiga-ui/kit';

type From = TuiDay | null;

type To = string | null;

@Injectable()
export class StrawberryDateTransformer extends TuiValueTransformer<From, To> {
  fromControlValue(controlValue: To): From {
    // Handle both null and empty strings as null
    if (!controlValue || controlValue === '') {
      return null;
    }

    try {
      return TuiDay.jsonParse(controlValue);
    } catch {
      // If parsing fails, return null instead of throwing
      return null;
    }
  }

  toControlValue(componentValue: From): To {
    return componentValue?.toString('YMD', '-') || null;
  }
}
@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'tui-input-date[toStrawberryDate]',
  providers: [
    {
      provide: TUI_DATE_VALUE_TRANSFORMER,
      useClass: StrawberryDateTransformer,
    },
  ],
  standalone: false,
})
export class StrawberryDateDirective {
  constructor() {}
}
